<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="20"
    height="20"
  >
    <g transform="translate(2.083 0.833)">
      <path
        d="M119.251,58.933a7.917,7.917,0,0,0-7.837-7.916,8,8,0,0,0-8,7.859,7.919,7.919,0,0,0,5.119,7.464,4.016,4.016,0,0,1,1.521,1.038,16.378,16.378,0,0,1,1.14,1.482.182.182,0,0,0,.287.009c.444-.53.9-1.136,1.366-1.618a4.059,4.059,0,0,1,1.414-.962,7.919,7.919,0,0,0,4.987-7.356"
        transform="translate(-103.417 -51.017)"
        :fill="color"
      />
      <path
        d="M124.03,67.156a4.359,4.359,0,1,1-4.358-4.358,4.358,4.358,0,0,1,4.358,4.358"
        transform="translate(-111.789 -59.308)"
        :fill="color"
      />
      <path
        d="M116.679,69.782a5.618,5.618,0,1,1,5.618-5.618A5.625,5.625,0,0,1,116.679,69.782Zm0-8.717a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,116.679,61.065Z"
        transform="translate(-108.797 -56.315)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  computed: {
    color: ({ $store }) => $store.getters['map/includesSpotsPin'] ? '#0174bf' : '#9d9d9d',
  },
};
</script>



// WEBPACK FOOTER //
// spot.vue?07ce8d80